import type { Calculation } from './Calculation';
import type { Purchase } from './Purchase';

export enum OrientationType {
  MortgageIncrease = 'MortgageIncrease',
  Purchase = 'Purchase',
  //TODO "v2/documents" task: replace InterestOnlyV2 with InterestOnly
  InterestOnly = 'InterestOnly',
  InterestOnlyV2 = 'InterestOnlyV2',
  Unknown = 'Unknown'
}

export enum OrientationStarter {
  HOStart = 'HOStart',
  HAStart = 'HAStart',
  AdvStart = 'AdvStart'
}

export interface Orientation {
  readonly mortgageIncreaseData?: Calculation;
  readonly purchaseData?: Purchase;
  readonly lastUpdate?: string;
  readonly type: OrientationType;
  readonly startedBy?: OrientationStarter;
}
